// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"56f606b8","444":"659fcb7c","460":"5c17f9ba","787":"727c45b9"}[chunkId] + ".chunk.js";
};